export enum QuizMode {
  BUZZER = "BUZZER",
  OX = "OX",
  ANSWER_INPUT = "ANSWER_INPUT"
}

export enum RoundState {
  WAITING = "WAITING",
  ACTIVE = "ACTIVE",
  STOPPED = "STOPPED"
}

export interface QuizPlayer {
  id: number;
  name: string;
  isHost: boolean;
  isBot: boolean;
}

export interface QuizRoomState {
  mode: QuizMode;
  question: string;
  roundState: RoundState;
  responses: QuizResponse[];
  showResults: boolean;
  players: QuizPlayer[];
  hostId: number;
  totalPlayers: number;
  responded: number;
  oCount?: number;
  xCount?: number;
}

export interface QuizResponse {
  playerId: number;
  playerName: string;
  response: string | boolean | number;
  order?: number; // For buzzer mode
  choice?: 'O' | 'X'; // For OX mode
  answer?: string; // For answer input mode
  timestamp: number;
}

// Socket Events
export const QuizProtocol = {
  // Host Controls (Emit)
  SET_MODE: 'quiz:set_mode',
  START_ROUND: 'quiz:start_round',
  STOP_ROUND: 'quiz:stop_round',
  RESET_ROUND: 'quiz:reset_round',
  CONTINUE_ROUND: 'quiz:continue_round',
  REVEAL_RESPONSES: 'quiz:reveal_responses',

  // Player Actions (Emit)
  BUZZER_PRESS: 'quiz:buzzer_press',
  OX_SUBMIT: 'quiz:ox_submit',
  ANSWER_SUBMIT: 'quiz:answer_submit',

  // Server Events (Listen)
  MODE_CHANGED: 'quiz:mode_changed',
  PHASE_READY: 'quiz:phase_ready',
  ROUND_STARTED: 'quiz:round_started',
  ROUND_STOPPED: 'quiz:round_stopped',
  ROUND_CONTINUED: 'quiz:round_continued',
  PLAYER_RESPONDED: 'quiz:player_responded',
  RESULTS_REVEALED: 'quiz:results_revealed',

  // Reconnection
  SYNC_GAME_STATE: 'quiz:sync_game_state'
} as const;

// Protocol Data Interfaces
export interface SetModeData {
  mode: QuizMode;
}

export interface StartRoundData {
  question: string;
}

export interface OXSubmitData {
  choice: 'O' | 'X';
}

export interface AnswerSubmitData {
  answer: string;
}

export interface ContinueRoundData {
  question?: string;
}

export interface ModeChangedData {
  mode: QuizMode;
}

export interface PhaseReadyData {
  mode: QuizMode;
  players: QuizPlayer[];
  hostId: number;
  roundState: RoundState;
  currentQuestion: string;
  responses: QuizResponse[];
}

export interface RoundStartedData {
  mode: QuizMode;
  question: string;
}

export interface PlayerRespondedData {
  playerId: number;
  playerName: string;
  order?: number;
  mode: QuizMode;
}

export interface ResultsRevealedData {
  mode: QuizMode;
  question: string;
  totalPlayers: number;
  responded: number;
  responses: QuizResponse[];
  oCount?: number;
  xCount?: number;
}